export class Error {

  constructor(
    public $key: string,
    public field: string,
    public cpu: string,
    public error: string,
    public timestamp: string,
    public user: string,
  ) {

  }

  static fromJson({$key, field, cpu, error, timestamp, user}) {
    return new Error($key, field, cpu, error, timestamp, user);
  }

  static fromJsonArray(json : any[]) : Error[] {
    return json.map(Error.fromJson);
  }

  static toError(r:any): Error {
    let error = <Error>({
      $key: r.$key,
      field: r.field,
      cpu: r.cpu,
      error: r.error,
      timestamp: r.timestamp,
      user: r.user,
    });

    //console.log('Parsed field:', field);
    return error;
  }

}

